export default __webpack_public_path__ + "static/media/IMG_4535-min.10cf34c3.JPG";